import { IRequestShortcutConfig, IPromise, IHttpService } from "angular";

import { IAnnouncement, IGetAnnoncementsParams } from "../models/announcements";
import { ICollection } from "@gtmhub/models";
import { EnvironmentService } from "@gtmhub/env";

export const defaultAnnouncementFields = "announcementTargetId,announcementType,authorId,comment,dateCreated,id,notificationStrategy,notify,reactions,mentions";

export class AnnouncementService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public delete(id: string): IPromise<IAnnouncement> {
    const url = this.env.getApiEndpoint("/announcements/" + id);

    return this.$http.delete<IAnnouncement>(url).then((response) => response.data);
  }

  public post(announcement: IAnnouncement): IPromise<IAnnouncement> {
    const url = this.env.getApiEndpoint("/announcements");

    return this.$http.post<IAnnouncement>(url, announcement).then((response) => response.data);
  }

  public patch(announcement: Partial<IAnnouncement>): IPromise<IAnnouncement> {
    const url = this.env.getApiEndpoint("/announcements/" + announcement.id);

    return this.$http.patch<IAnnouncement>(url, announcement).then((response) => response.data);
  }

  public get(params: IGetAnnoncementsParams): IPromise<ICollection<IAnnouncement>> {
    const url = this.env.getApiEndpoint("/announcements");
    if (!params.fields) {
      params.fields = defaultAnnouncementFields;
    }

    const config: IRequestShortcutConfig = {
      params,
    };

    return this.$http.get<ICollection<IAnnouncement>>(url, config).then((response) => response.data);
  }
}
